import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Header } from './header';
export var MainContainer = function MainContainer(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs("div", {
        className: "bg-[var(--color-primary-bg)]",
        children: [
            /*#__PURE__*/ _jsx(Header, {}),
            /*#__PURE__*/ _jsx("div", {
                className: "flex w-full justify-center items-center",
                style: {
                    height: 'calc(100vh - 80px)'
                },
                children: children
            })
        ]
    });
};
